import { Spinner, Text, FlexRow } from '@epam/promo';
import { useQuery } from '@tanstack/react-query';
import { getSuperAdmins } from 'api/admin.service';
import { LoginContainer } from 'components/layouts/LoginContainer';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserStore } from 'store/user';
import { REVOKED_STATUS } from 'models/user.model';
import NoAccessBotIcon from '../../assets/images/no-access-bot.png';
import css from './NoAccessPage.module.scss';

export const NoAccessPage = () => {
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);
  const { data: superAdmins, isLoading } = useQuery({
    queryKey: ['superAdmins'],
    queryFn: getSuperAdmins,
    retry: false,
  });

  useEffect(() => {
    if (!user) {
      navigate('/login', { replace: true });
    } else if (user.role !== 'GUEST' && user.status !== REVOKED_STATUS) {
      navigate('/home', { replace: true });
    }
  }, [navigate, user]);

  return (
    <LoginContainer>
      <FlexRow cx={css.noAccessPage__info}>
        <Text cx={css.noAccessPage__title}>NO ACCESS</Text>
        <Text cx={css.noAccessPage__description} fontSize="18">
          Please, contact super admin at
        </Text>
        <div className={css.noAccessPage__admins}>
          {isLoading && <Spinner />}
          {superAdmins?.map((email) => (
            <a
              key={email}
              className={css['noAccessPage__description--email']}
              href={`mailto:${email}`}>
              {email}
            </a>
          ))}
        </div>
      </FlexRow>
      <img alt="no access bot icon" src={NoAccessBotIcon} />
    </LoginContainer>
  );
};
